import React, { useState } from "react";
import api from "../../services/api";
import { Col, Row } from "react-bootstrap";
import styleTab from "../../components/Tab/Tab.module.css";
import styles from "./style.module.css";
import StarRate from "../StarRate";
import ModalCustom from "./modal-template-default";
import { InputTextArea } from "../Input";
import Button from "../Button";
import { toast } from "react-toastify";
import useWrapper from "../../hooks/useWrapper";

const ModalEndService = props => {
  const { show, closeModal, id } = props;
  const { config } = useWrapper();

  const [rate, setrate] = useState();
  const [isLoadingSave, setisLoadingSave] = useState(false);

  const sendRate = async () => {
    if (!rate?.stars && !rate?.like) {
      toast.error("Nos avalie antes de concluir este Atendimento.");
      return;
    }
    try {
      setisLoadingSave(true);
      await api.put(
        `trainee/attendance/${id}`,
        {
          avaliation: rate?.stars,
          attended: rate?.like,
          attended_text: rate?.text,
        },
        config,
      );
      toast.success("Atendimento concluído e avaliado com sucesso!");
      onHide();
    } catch (__error) {
      console.log("__error", __error);
      toast.error("Erro ao tentar avaliar o atendimentto!");
    } finally {
      setisLoadingSave(false);
    }
  };

  const onHide = () => {
    setrate();
    closeModal();
  };

  return (
    <>
      <ModalCustom size="md" show={show} onHide={onHide} centered disableClose={!!isLoadingSave}>
        <ModalCustom.Header>
          <div>
            <h2 className="page-title">Como foi o nosso atendimento?</h2>
          </div>
        </ModalCustom.Header>

        <ModalCustom.Body>
          <Row>
            <Col>
              <p className="small-label mb-3">
                Você pode ajudar a gente a ser cada vez melhor respondendo a nossa pesquisa de satisfação, então conta
                pra gente!
              </p>
              <p>De 1 à 5 estrelas, qual seria sua nota para este atendimento?</p>
              <StarRate
                rate={rate?.stars}
                setRate={__ev => {
                  setrate({
                    ...rate,
                    stars: __ev,
                  });
                }}
                className="mb-3"
              />
              <div className="mb-3">
                <p>A sua solicitação foi atendida?</p>
                <Row>
                  <Col sm={4}>
                    <div className={styleTab.tab}>
                      <button
                        type="button"
                        onClick={() => {
                          setrate({
                            ...rate,
                            like: true,
                          });
                        }}
                        className={!!rate?.like && "active"}
                      >
                        Sim :)
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setrate({
                            ...rate,
                            like: false,
                          });
                        }}
                        className={rate?.like === false && "active"}
                      >
                        Não :(
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className={styles.writeComment}>
                <InputTextArea
                  required={true}
                  disabled={!!isLoadingSave}
                  rows={4}
                  value={rate?.text || ""}
                  onChange={__ev => {
                    setrate({
                      ...rate,
                      text: __ev.target.value,
                    });
                  }}
                  placeholder="Poderia nos falar mais sobre isso?"
                />
              </div>
            </Col>
          </Row>
        </ModalCustom.Body>
        <ModalCustom.Footer>
          <Button loading={!!isLoadingSave} color={"success"} onClick={sendRate}>
            Enviar Avaliação
          </Button>
        </ModalCustom.Footer>
      </ModalCustom>
    </>
  );
};

export default ModalEndService;
